
import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { LoginButton } from "@/components/auth/LoginButton";
import { useAuthBypass } from "@/lib/auth";

const isAuthDisabled = true;

export const AuthenticationWrapper = ({ children }: { children: React.ReactNode }) => {
  const auth = isAuthDisabled ? useAuthBypass() : useAuth0();
  const { isAuthenticated, isLoading } = auth;

  if (isLoading) {
    return <div className="min-h-screen bg-ticker-bg text-ticker-text flex items-center justify-center">
      Loading...
    </div>;
  }

  if (!isAuthenticated) {
    return <div className="min-h-screen bg-ticker-bg text-ticker-text flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-3xl font-bold mb-4">Welcome to Sports Ticker Control</h1>
        <p className="mb-4">Please log in to continue</p>
        <LoginButton />
      </div>
    </div>;
  }

  return <>{children}</>;
};
